/* THIS FILE IS GENERATED BY DataGridTypeScriptGenerator. */
import { defineDashboard } from './contract'

export const agentsOverviewDashboard = defineDashboard({
  "id": "agents-overview",
  "searchMinimumLength": null,
  "fields": {
    "agent": {
      "label": "Agent",
      "kind": "category",
      "operators": [
        "in",
        "empty"
      ],
      "options": null
    },
    "connection": {
      "label": "Connection",
      "kind": "category",
      "operators": [
        "in",
        "empty"
      ],
      "options": {
        "Online": "Online",
        "Offline": "Offline"
      }
    },
    "releasesBehind": {
      "label": "Releases behind",
      "kind": "number",
      "operators": [
        "equals",
        "atLeast",
        "atMost",
        "between",
        "empty"
      ],
      "options": null
    },
    "severity": {
      "label": "Severity",
      "kind": "number",
      "operators": [
        "equals",
        "atLeast",
        "atMost",
        "between",
        "empty"
      ],
      "options": null
    },
    "releaseChannel": {
      "label": "Release channel",
      "kind": "category",
      "operators": [
        "in",
        "empty"
      ],
      "options": null
    },
    "agentVersion": {
      "label": "Agent version",
      "kind": "category",
      "operators": [
        "in",
        "empty"
      ],
      "options": null
    },
    "osFamily": {
      "label": "OS family",
      "kind": "category",
      "operators": [
        "in",
        "empty"
      ],
      "options": {
        "Windows": "Windows",
        "Linux": "Linux",
        "MacOs": "macOS",
        "Other": "Other"
      }
    },
    "osEdition": {
      "label": "OS edition",
      "kind": "text",
      "operators": [
        "equals",
        "contains",
        "startsWith",
        "endsWith",
        "empty"
      ],
      "options": null
    },
    "osSupport": {
      "label": "OS support",
      "kind": "category",
      "operators": [
        "in",
        "empty"
      ],
      "options": {
        "Supported": "Supported",
        "Unsupported": "Unsupported"
      }
    },
    "entity": {
      "label": "Entity",
      "kind": "category",
      "operators": [
        "in",
        "empty"
      ],
      "options": null
    },
    "lastSeen": {
      "label": "Last seen",
      "kind": "timestamp",
      "operators": [
        "before",
        "after",
        "between",
        "relative",
        "age",
        "empty"
      ],
      "options": null
    }
  }
} as const)
